<div style="overflow-x: hidden;">
<app-website-header></app-website-header>
<div class="header">
  <img src="../../../../assets/images/latest_news_trends.jpg" width="100%" height="360px" style="transform: scaleX(-1);" />
  <div class="header-name">
      <p style="font-family: 'Libre Baskerville' !important;">Latest News</p>
  </div>
</div>

<div *ngFor="let category of newsCategories" class="top" >
  <div class="row mt-1 top-products">
    <div class="d-flex align-items-center mt-4 mb-4 headers gap-2">
      <img [src]="category.imageLink" alt="landingpage" class="products ml-auto" style="margin-left: 1%" width="24px" height="24px" />
      <h2 class="products mx-2 fw-bold products-title" style="color: white; font-weight: bolder; font-size: 12; font-family: 'Georgia' !important;">
        {{ category.title }}
      </h2>

    </div>
  </div>

  <div class="products-container d-flex flex-wrap justify-content-start" style="margin-left: 3%; margin-right: 2rem;">
    <ng-container *ngFor="let news of category.data | slice:0:category.visibleNewsCount">
      <div class="news-card m-2" style="position: relative; width: 18%; max-width: 262px; min-height: 350px; border: 1px solid #F5F5F5; box-shadow: 0px 4px 16px 0px #0000000D; cursor: pointer;" (click)="redirectToNews(news?.link)">
        <div class="card-img">
          <img [src]="news.image" class="image-align" width="100%" height="130px">
        </div>
        <div class="card-heading" style="font-weight: bold; color: black;">
          <p [innerHTML]="news.title | truncateText:50"></p>
        </div>
        <div class="news-card-info">
          <p  [innerHTML]="news.description | truncateText:250" style="text-align: left; font-size: 12px; display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 5;"></p>
        </div>
        <div class="view-more" style="position: absolute; bottom: 10px; right: 10px;">
          <span style="text-decoration: none; color: #0D6EFD;">View More</span>
        </div>
      </div>
    </ng-container>
  </div>


  <div class="d-flex justify-content-center mt-4 load">
    <button *ngIf="category.data.length > category.visibleNewsCount"
            (click)="loadMoreNews(category)"
            class="btn btn-primary mb-4 load-more"
            style="background-color: #0D87C8; color: white;">
      Load More
    </button>
  </div>
</div>

<app-website-footer></app-website-footer>
</div>
